<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense flat color="white" class="toolbar">
                <v-toolbar-title>Subject Preference Form</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <div class="justify-center mb-5 mt-4" align="center">
                <!-- <v-row justify="center" dense no-gutters>
                    <v-col cols="12" sm="2" md="2">
                        <div class="d-flex align-center">
                            <v-icon color="error" small class="mr-1 mb-12"> *</v-icon>
                            <v-autocomplete v-model="sel_ay_data" :items="ay_list" item-text="ay" return-object
                                label="Academic Year" color="#0F2027" outlined dense rounded persistent-hint
                                hint="Please Select Academic Year" class="mt-2" />
                        </div>
                    </v-col>
                    <v-col v-if="sel_ay_data" cols="auto" class="d-flex align-center ml-2 mb-5">
                        <v-btn color="primary" small @click="getPreferenceData();getElectiveChoiceFeeDetails()">Fetch</v-btn>
                    </v-col>
                </v-row> -->

                <v-row justify="center" dense no-gutters>

                    <!-- STUDENT -->
                    <template >
                        <v-col cols="12" sm="3" md="3">
                            <div class="d-flex align-center">
                                <v-icon color="error" small class="mr-1 mb-12">*</v-icon>
                                <v-autocomplete v-model="sel_ay_data" :items="ay_list" item-text="ay" return-object
                                    label="Academic Year" color="#0F2027" outlined dense rounded persistent-hint
                                    hint="Please Select Academic Year" class="mt-2" />
                            </div>
                        </v-col>
                    </template>

                    <!-- PARENT -->
                    <template v-if="usertype == 'Parent'">
                        <v-col cols="12" sm="3" md="3">
                             <div class="d-flex align-center">
                            <v-icon color="error" small class="mr-1 mb-12">*</v-icon>
                            <v-autocomplete v-model="selected_children" :items="children" item-text="name" return-object
                                label="Child" color="#0f2027" rounded outlined dense
                                prepend-icon="mdi-account-child-circle" class="mt-2"
                                @change="learner = selected_children.username" />
                             </div>
                        </v-col>
                    </template>

                    <!-- FETCH BUTTON -->
                    <v-col v-if="sel_ay_data" cols="auto" class="d-flex align-center ml-2 mb-5">
                        <v-btn color="primary" small @click="getPreferenceData(); getElectiveChoiceFeeDetails()">
                            Fetch
                        </v-btn>
                    </v-col>

                </v-row>

                <v-card class="summary-card elevation-4 mt-4" v-if="learner_data.length > 0">
                    <v-row justify="center" no-gutters v-if="learner_data.length > 0">
                        <v-col cols="12">
                            <table class="summary-table">
                                <tr>
                                    <th>PRN</th>
                                    <th>Student Name</th>
                                    <th>Academic Year</th>
                                    <th>Standard</th>
                                    <th>Stream</th>
                                </tr>
                                <tr v-for="(item, i) in learner_data" :key="i">
                                    <td>{{ item.prn }}</td>
                                    <td>{{ item.name_of_candidate }}</td>
                                    <td>{{ item.ay }}</td>
                                    <td>{{ item.standard }}</td>
                                    <td>{{ item.stream }}</td>
                                </tr>
                            </table>
                        </v-col>
                    </v-row>

                </v-card>
            </div>

            <div v-if="preference_list.length > 0" class="table-wrapper">
                <table class="preference-table mt-4">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Subject Head</th>
                            <th>Selection Type</th>
                            <th>Pick-Up Count</th>
                            <th>Subject/Group</th>
                            <th>Fees</th>
                            <th>Choice No</th>
                            <th>Move</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in preference_list" :key="index"
                            v-if="is_already_saved || !item.is_auto_allot || item.srno !== ''" @dragover.prevent
                            @drop="(!is_already_saved && !item.is_auto_allot) ? dropRow(index) : null">

                            <td v-if="item.srno !== ''"
                                :rowspan="item.is_auto_allot && !is_already_saved ? 1 : item.rowspan_count">
                                {{ item.srno }}
                            </td>
                            <td v-if="item.course_head_name !== ''"
                                :rowspan="item.is_auto_allot && !is_already_saved ? 1 : item.rowspan_count">
                                {{ item.course_head_name }}
                            </td>
                            <td v-if="item.selection_type_name !== ''"
                                :rowspan="item.is_auto_allot && !is_already_saved ? 1 : item.rowspan_count">
                                {{ item.selection_type_name }}
                            </td>
                            <td v-if="item.elective_pickup_count !== ''"
                                :rowspan="item.is_auto_allot && !is_already_saved ? 1 : item.rowspan_count">
                                {{ item.elective_pickup_count }}
                            </td>

                            <!-- <td>
                                <div v-if="is_already_saved || !item.is_auto_allot">
                                    {{ item.subject_group }}
                                </div>
                                <div v-else>
                                    <v-autocomplete v-model="item.selected_ids" :items="getGroupOptions(item.srno)"
                                        item-text="subject_group" item-value="id_to_save"
                                        :label="'Select ' + item.elective_pickup_count + ' subject(s)'"
                                        :multiple="item.elective_pickup_count > 1" chips small-chips deletable-chips
                                        outlined dense hide-details @change="onDropdownChange(item)" />
                                </div>
                            </td> -->
                            <td>
                            <div v-if="is_already_saved || !item.is_auto_allot">
                                <v-tooltip top color="indigo darken-4" open-delay="200">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on" class="group-text">
                                            {{ item.subject_group }}
                                            <v-icon x-small color="grey" v-if="item.subjects && item.subjects.length > 0">mdi-information-outline</v-icon>
                                        </span>
                                    </template>
                                    <div class="pa-1">
                                        <div v-for="(sub, sIdx) in item.subjects" :key="sIdx" class="caption">
                                            • {{ sub }}
                                        </div>
                                    </div>
                                </v-tooltip>
                            </div>

                                    <div v-else>
                                        <v-autocomplete 
                                            v-model="item.selected_ids" 
                                            :items="getGroupOptions(item.srno)"
                                            item-text="subject_group" 
                                            item-value="id_to_save"
                                            :label="'Select ' + item.elective_pickup_count + ' subject(s)'"
                                            :multiple="item.elective_pickup_count > 1" 
                                            chips small-chips deletable-chips
                                            outlined dense hide-details 
                                            @change="onDropdownChange(item)"
                                        >
                                            <template v-slot:item="{ item }">
                                                <v-tooltip right color="indigo darken-4">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-list-item-content v-bind="attrs" v-on="on">
                                                            <v-list-item-title>{{ item.subject_group }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                    <div v-for="sub in item.subjects" :key="sub" class="caption">• {{ sub }}</div>
                                                </v-tooltip>
                                            </template>

                                            <template v-slot:selection="{ item, selected, index }">
                                                <v-tooltip top color="indigo darken-4">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :input-value="selected"
                                                            close
                                                            @click:close="item.elective_pickup_count > 1 ? item.selected_ids.splice(index, 1) : item.selected_ids = null"
                                                        >
                                                            {{ item.subject_group }}
                                                        </v-chip>
                                                    </template>
                                                    <div v-for="sub in item.subjects" :key="sub" class="caption">• {{ sub }}</div>
                                                </v-tooltip>
                                            </template>
                                        </v-autocomplete>
                                    </div>
                                </td>

                            <td>{{ item.fees }}</td>
                            <td>
                                <span class="choice-badge">
                                    {{ (item.is_auto_allot && !is_already_saved) ? 'Auto' : item.choice_no }}
                                </span>
                            </td>

                            <td width="80">
                                <div v-if="!is_already_saved">
                                    <div v-if="!item.is_auto_allot" class="drag-container">
                                        <v-icon color="primary" draggable
                                            @dragstart="dragStart(index)">mdi-drag</v-icon>
                                    </div>
                                    <div v-else>
                                        <v-icon color="grey lighten-2">mdi-lock</v-icon>
                                    </div>
                                </div>
                                <div v-else>
                                    <v-icon color="success">mdi-check-decagram</v-icon>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="preference_list.length > 0">
                    <v-alert dense outlined :type="is_already_saved ? 'success' : 'warning'" class="mx-5 mb-4 caption">
                        <div v-if="!is_already_saved">
                            <strong>Note:</strong> Please review your choices carefully. Once you click <strong>'Submit
                                Selections'</strong>, your preferences will be locked and cannot be changed.
                        </div>
                        <div v-else>
                            <strong>Note:</strong> You have already submitted your preferences. The form is now in
                            view-only mode.
                        </div>
                    </v-alert>

                    <div class="text-center mt-5 mb-5">
                        <v-btn color="primary" class="px-8" @click="submitPreference()"
                            :disabled="is_already_saved || overlay">
                            {{ is_already_saved ? 'Preferences Submitted' : 'Submit Selections' }}
                        </v-btn>
                    </div>
                </div>
            </div>

              <v-col cols="12" md="12" sm="12" class="px-0">
                    <v-data-table
                        :items="receipts"
                        :headers="headers"
                        v-if="receipts!=''"
                        class="elevation-1 mytable"
                        dense
                        :search="search"
                    >
                        <template v-slot:[`item.print`]="{ item }">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="my-2"
                                        outlined
                                        rounded
                                        small
                                        color="warning"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="print(item.receipt_no, item.ay,item.registration_number)"
                                    >
                                        <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn
                                    >
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-col>

                <v-row justify="center" dense class="no-display" v-if="choice_list!=null">
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Allotted Subject / Group </strong>
                    </v-toolbar-title>
                </v-toolbar>
                 <v-col cols="12" md="12" sm="12" class="px-0">
                    <v-data-table
                        :items="choice_list"
                        :headers="headers_choice_list"
                        v-if="choice_list!=''"
                        class="elevation-1 mytable"
                        dense
                    >
                      <template v-slot:item.is_fees_paid="{ item }">
                    <span v-if="item.is_fees_paid">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                    </v-data-table>
                     <v-col cols="12" md="12" sm="12" class="px-0">
                        <center> <strong>Total Fees : {{ total_fees }}</strong> </center>
                     </v-col>
                </v-col>
            </v-row>
            <v-row justify="center" dense class="no-display" v-if="choice_list!=null">
                <v-btn
                    small
                    class="button"
                    v-if="pgs.includes('CCAVENUE')"
                    @click="initiateInvoiceCCAvenuePayment()"
                    :loading="loader"
                    :disabled="total_fees == 0"
                    >Pay Online [CCAVENUE]</v-btn
                >
            </v-row>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        learner: "",
        sel_ay_data: null,
        preference_list: [],
        ay_list: [],
        learner_data: [],
        dragIndex: null,
        is_already_saved: false,
        sel_ay_data: null,
                orgid: null,
                uid: null,
                tenant: null,
                matrixPgList: null,
                choice_list: null,
                total_fees: null,
                studid: null,
                ay_id: null,
                hash_val: null,
                pgs: null,
                matrix_pg_list: null,
                stud_data: null,
                ay_name: null,
                receipts: [],
                total_fees:null,
                usertype:null,
                children:[],
                selected_children:null,

         headers: [
                    { text: "Sr. No.", value: "srno", sortable: true, align: "center" },
                    { text: "Receipt No", value: "receipt_no", sortable: true, align: "center" },
                    { text: "Amount", value: "amount", sortable: true, align: "center" },
                    { text: "Date", value: "receipt_date", sortable: true, align: "center" },
                    { text: "Payment Mode", value: "payment_mode", sortable: true, align: "center" },
                    { text: "Remark", value: "remark", sortable: true, align: "center" },
                    { text: "Print Receipt", value: "print", sortable: true, align: "center" },
                ],
                headers_choice_list:[
                    { text: "Sr. No.", value: "srno", sortable: true, align: "center" },
                    { text: "Choice Number", value: "ch_no", sortable: true, align: "center" },
                    { text: "Subject Head", value: "sub_head", sortable: true, align: "center" },
                    { text: "Selection Type", value: "selectiontype", sortable: true, align: "center" },
                    { text: "Subject / Group", value: "course", sortable: true, align: "center" },
                    { text: "Fees", value: "fees", sortable: true, align: "center" },
                    { text: "Is Fees Paid ?", value: "is_fees_paid", sortable: true, align: "center" },
                    { text: "Fees Paid Amount", value: "fees_paid_amount", sortable: true, align: "center" },
                    { text: "Fees Payment Date", value: "fees_payment_date", sortable: true, align: "center" },
                ]

    }),

    methods: {
        getAy() {
            axios.post("/commonAPI/get_ay_std_div")
                .then((res) => { 
                    this.ay_list = res.data.data; 
                })
                .catch(() => { this.showSnackbar("#b71c1c", "Failed to load Academic Years"); });
        },

        getPreferenceData() {
            if (!this.sel_ay_data) return;
            var lid 
            if(this.usertype == "Parent"){
               lid = this.selected_children.id
            }else{
               lid = this.learner
            }
            const data = { ay: this.sel_ay_data.ay_id, learner: lid, usertype: this.usertype };

            this.overlay = true;
            axios.post("/admission/getPreferenceData", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.is_already_saved = res.data.is_already_saved; // Capture the flag

                        const rawList = res.data.preference_list || [];

                        this.preference_list = rawList.map(item => {
                            const stableId = item.subject_group_id ? item.subject_group_id : item.course_offering_id;

                            // PRE-POPULATE: If auto-allot and already saved, we need to fill selected_ids
                            // Assuming choice_no contains data if already saved
                            let preselected = item.elective_pickup_count > 1 ? [] : null;
                            if (this.is_already_saved && item.choice_no) {
                                // This logic depends on how you return 'saved' auto-allot data
                                // If it's saved, we assume it's part of the selections
                            }

                            return {
                                ...item,
                                id_to_save: stableId,
                                selected_ids: preselected
                            };
                        });

                        this.learner_data = res.data.learner_data || [];
                        this.updateChoiceNo();
                        // this.getElectiveChoiceFeeDetails();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.msg);
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.showSnackbar("#b71c1c", "Error fetching data");
                });
        },

        getGroupOptions(srno) {
            const startIndex = this.preference_list.findIndex(it => it.srno === srno);
            if (startIndex === -1) return [];
            const count = this.preference_list[startIndex].rowspan_count;
            return this.preference_list.slice(startIndex, startIndex + count);
        },

        onDropdownChange(item) {
            // Logic to handle both single and multiple selection models
            let currentSelection = item.selected_ids;

            if (item.elective_pickup_count > 1) {
                // Multiple mode
                if (currentSelection.length > item.elective_pickup_count) {
                    this.showSnackbar("#b71c1c", `Maximum ${item.elective_pickup_count} selections allowed`);
                    item.selected_ids.pop();
                }
            }
        },

        submitPreference() {
            // 1. Security Check
            if (this.is_already_saved) {
                this.showSnackbar("#b71c1c", "Preferences are already submitted.");
                return;
            }

            if (this.preference_list.length === 0) {
                this.showSnackbar("#b71c1c", "No preferences to save.");
                return;
            }

            // 2. Build the final selection list
            const finalSelections = [];

            this.preference_list.forEach((item, index) => {
                // Find the "Header" row for this group to check is_auto_allot status
                let headerRow = null;
                for (let i = index; i >= 0; i--) {
                    if (this.preference_list[i].srno !== "") {
                        headerRow = this.preference_list[i];
                        break;
                    }
                }

                if (!headerRow) return;

                if (headerRow.is_auto_allot) {
                    // --- AUTO ALLOT LOGIC ---
                    // We only add this specific item if its ID is inside the header's dropdown selection
                    const selected = headerRow.selected_ids;

                    // Check if selected is an array (multiple) or single value
                    const isSelected = Array.isArray(selected)
                        ? selected.includes(item.id_to_save)
                        : selected === item.id_to_save;

                    if (isSelected) {
                        finalSelections.push(item);
                    }
                } else {
                    // --- MANUAL RANK LOGIC ---
                    // All manual items are included because their order is determined by their position in the list
                    finalSelections.push(item);
                }
            });

            // 3. Validation
            if (finalSelections.length === 0) {
                this.showSnackbar("#b71c1c", "Please make your selections before submitting.");
                return;
            }

            // 4. Confirmation
            if (!confirm("Are you sure you want to submit? You will not be able to edit these choices later.")) {
                return;
            }

            // 5. API Call
            this.overlay = true;
            var lid

            if(this.usertype == "Parent"){
                lid = this.selected_children.id
            }else{
                lid = this.learner
            }
            axios.post("/admission/saveElectivePreference", {
                ay: this.sel_ay_data.ay_id,
                learner: lid,
                usertype: this.usertype,
                preference_list: finalSelections
            })
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#2e7d32", res.data.msg);
                        // Re-fetch to lock the UI and show the "Saved" state
                        this.getPreferenceData();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.msg);
                    }
                })
                .catch((err) => {
                    this.overlay = false;
                    console.error("Save Error:", err);
                    this.showSnackbar("#b71c1c", "Save failed. Please try again.");
                });
        },

        dragStart(index) {
            if (this.is_already_saved) return;
            this.dragIndex = index;
        },

        updateChoiceNo() {
            let counter = 0;
            this.preference_list.forEach((item) => {
                if (item.is_auto_allot) {
                    this.$set(item, "choice_no", "Auto");
                } else {
                    if (item.srno !== "") counter = 1;
                    else counter++;
                    this.$set(item, "choice_no", counter);
                }
            });
        },

        findGroupSrNo(index) {
            for (let i = index; i >= 0; i--) {
                if (this.preference_list[i].srno !== "") return this.preference_list[i].srno;
            }
            return "";
        },

        dragStart(index) { this.dragIndex = index; },

        dropRow(dropIndex) {
            if (this.dragIndex === null || this.dragIndex === dropIndex) return;

            const dragItem = this.preference_list[this.dragIndex];
            const dropItem = this.preference_list[dropIndex];

            if (dragItem.is_auto_allot || dropItem.is_auto_allot) {
                this.showSnackbar("#b71c1c", "Cannot reorder Auto-Allot items");
                return;
            }

            if (this.findGroupSrNo(this.dragIndex) !== this.findGroupSrNo(dropIndex)) {
                this.showSnackbar("#b71c1c", "Reorder only within the same head");
                return;
            }

            const fields = ["subject_group", "fees", "choice_no", "course_offering_id", "subject_group_id", "id_to_save"];
            fields.forEach(field => {
                const temp = this.preference_list[this.dragIndex][field];
                this.$set(this.preference_list[this.dragIndex], field, this.preference_list[dropIndex][field]);
                this.$set(this.preference_list[dropIndex], field, temp);
            });

            this.updateChoiceNo();
            this.dragIndex = null;
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
          async initiateInvoiceCCAvenuePayment() {
                let formData = new FormData();
                formData.append("orgid", this.orgid);
                formData.append("tenantid", this.tenant);
                formData.append("ay", this.ay_id);
                formData.append("uid", this.uid);
                formData.append("studid", this.studid);
                formData.append("fee_amount", this.total_fees);
                formData.append("json_pre_trans_data", this.matrix_pg_list);
                formData.append("hash_val", this.hash_val);
                formData.append("payment_type", "ELECTIVE FEES");
                formData.append("purpose", "ELECTIVE Fees");
                axios
                    .post("/paymentGatewayCCAvenue/initiateInvoiceCCAvenuePayment", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            var actionurl = res.data.redirection;
                            var access_code = res.data.merchant_key;
                            var encRequest = res.data.txnToken;
                            if (actionurl && encRequest && access_code) {
                                this.ccavenueRedirection(actionurl, encRequest, access_code);
                            }
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fsmg);
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.loader = false;
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    });
            },
            ccavenueRedirection(actionurl, token, access_code) {
                var form = document.createElement("form");
                var encRequest = document.createElement("input");
                var access_codes = document.createElement("input");

                form.method = "POST";
                form.id = "nomsemless";
                form.action = actionurl;

                encRequest.value = token;
                encRequest.name = "encRequest";
                encRequest.id = "encRequest";
                encRequest.type = "hidden";
                form.appendChild(encRequest);

                access_codes.value = access_code;
                access_codes.name = "access_code";
                access_codes.id = "access_code";
                access_codes.type = "hidden";
                form.appendChild(access_codes);

                document.body.appendChild(form);
                document.getElementById("nomsemless").style.display = "none";
                form.submit();
            },
            print(receipt_no, ay,registration_number) {
                this.receipt_no = receipt_no;
                // this.dialog_print = true;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                if (this.tenant == "zeal") {
                    alert("Under development....");
                } else if (this.tenant == "wws") {
                    alert("Under development....");
                } else if (this.tenant == "uwws") {
                    alert("Under development....");
                } else if (this.tenant == "vvp") {
                    alert("Under development....");
                } else if (this.tenant == "sanjivani") {
                    alert("Under development....");
                } else if (this.tenant == "desschool") {
                    let routeData = this.$router.resolve({
                        name: "student-elective-fees-receipts-des",
                    });
                    window.open(routeData.href, "_blank");
                } else {
                    alert("Under development....");
                }
            },
            async getElectiveChoiceFeeDetails() {
                var lid 
                    if(this.usertype == "Parent"){
                    lid = this.selected_children.id
                    }else{
                    lid = this.learner
                    }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    learner : lid,
                    usertype: this.usertype
                };
                try {
                    const res = await axios.post("/Admission/getElectiveChoiceFeeDetails", data);
                    if (res.data.flag == "YES") {
                        this.choice_list = res.data.choice_list;
                        this.matrixPgList = res.data.matrixPgList;
                        this.matrix_pg_list = JSON.stringify(this.matrixPgList);
                        this.total_fees = res.data.total_fees;
                        this.studid = res.data.studid;
                        this.ay_id = res.data.ay_id;
                        this.hash_val = res.data.hash_val;
                        this.stud_data = res.data.stud_data;
                        this.ay_name = res.data.ay_name;
                        this.receipts = res.data.receipts;
                        this.total_fees = res.data.total_fees;
                        this.pgs = res.data.pgs;
                        if (this.choice_list == null) {
                            this.showSnackbar("#b71c1c", "No Data Found....");
                        }
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg);
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            async loadParentChildData() {

            try {

                const res = await axios.post("/AccountingAndFees/getChildList");
                if (res.data.msg == "200" && res.data.status === "SUCCESS") {
                    this.children = res.data.learners;

                    if (this.children.length > 0) {
                        this.selected_children = this.children[0];
                        this.learner = this.selected_children.username;
                    }
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }

            } catch (error) {
                console.log(error);
                this.showSnackbar("#b71c1c", "Something went wrong");
            }
        }

    },

    mounted() {
        this.learner = localStorage.getItem("EPS-uid");
        this.orgid = localStorage.getItem("EPS-org-id");
        this.tenant = localStorage.getItem("EPS-tenant");
        this.uid = localStorage.getItem("EPS-uid");
        this.usertype = localStorage.getItem("EPS-ut");
        if (this.usertype === "Parent") {
            this.loadParentChildData();
        }
        this.getAy();
    }
};
</script>

<style scoped>
.table-wrapper {
    width: 100%;
    overflow-x: auto;
}

.preference-table {
    width: 100%;
    border-collapse: collapse;
}

.preference-table th {
    background-color: #1e3a5f;
    color: #ffffff;
    padding: 12px;
    border: 1px solid #cfd8dc;
    font-size: 13px;
}

.preference-table td {
    padding: 10px;
    border: 1px solid #dfe6e9;
    text-align: center;
    font-size: 13px;
    background-color: #ffffff;
}

/* Update these two classes in your <style> section */

.summary-card {
    /* mx-auto handles horizontal centering, 
       fit-content ensures the card wraps tightly around the table */
    width: fit-content;
}

.summary-table {
    width: auto;
    /* Change from 100% to auto */
    min-width: 500px;
    /* Optional: ensures it's not TOO small on wide screens */
    border-collapse: collapse;
}

.summary-table th {
    background-color: #1e3a5f;
    color: #ffffff;
    padding: 12px 20px;
    /* Added horizontal padding for better spacing */
    border: 1px solid #cfd8dc;
    white-space: nowrap;
    /* Keeps headers on one line */
}

.summary-table td {
    background-color: #f4f6f8;
    padding: 12px 20px;
    border: 1px solid #dfe6e9;
    text-align: center;
}

.choice-badge {
    background-color: #dbeafe;
    color: #1e40af;
    padding: 6px 12px;
    border-radius: 20px;
    font-weight: bold;
}

.drag-icon {
    cursor: grab;
}
</style>